import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Toast from '../components/Toast';

const BankAccountForm = () => {
  const navigate = useNavigate();
  const token = window.sessionStorage.getItem("usrtk");
  const [form, setForm] = useState({accountNumber: "", accountEmail: "", paymentName: "", paymentDescription: ""});
  const [loading, setLoading] = useState(false);

  const inputChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  }

  useEffect(() => {
    if (!token) {
      Toast.fire({icon: "error", title: "You need to be logged in"})
      .then(() => navigate("/login"));
    } 

    setLoading(true);

    fetch(`${process.env.REACT_APP_SERVER_URL}/users/getpaymentdetails`, 
      {
        headers: {
            "authorization": `Bearer ${token}`
        }
      }
    )
    .then(r => r.json())
    .then(res => {
      setLoading(false);
      if (res.type === "error") {
        return Toast.fire({icon: "error", title: res.message}).then(() => navigate('/dashboard'));;
      }
      console.log(res)
      setForm(res);
    })
    .catch((err) => {
      setLoading(false);
      Toast.fire({icon: "error", title: "Server error"});
    })

  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    fetch(`${process.env.REACT_APP_SERVER_URL}/users/setpaymentdetails`, 
      {
        method: "POST",
        body: JSON.stringify(form),
        headers: {
          "Content-Type": "application/json",
            "authorization": `Bearer ${token}`
        }
      }
    )
    .then(r => r.json())
    .then(res => {
      setLoading(false);
      if (res.type === "error") {
        return Toast.fire({icon: "error", title: res.message});
      }
      Toast.fire({icon: "success", title: "Payment details updated successfully!"})
      .then(() => navigate('/orders'));
    })
    .catch((err) => {
      setLoading(false);
      Toast.fire({icon: "error", title: "Server error"});
    })

  };

  return (
    <div className="container">
      <h1>Set Your Payment Details</h1>
      <form onSubmit={handleSubmit} className='login'>
        <label>Account Number:</label>
        <input
          type="text"
          value={form.accountNumber}
          name='accountNumber'
          onChange={inputChange}
        />

        <label>Account Email:</label>
        <input
          type="email"
          value={form.accountEmail}
          name='accountEmail'
          onChange={inputChange}
        />

        <label>Desired Transfer Payer Name:</label>
        <input
          type="text"
          value={form.paymentName}
          name='paymentName'
          onChange={inputChange}
        />

        <label>Payment Description:</label>
        <textarea name="paymentDescription" onChange={inputChange} value={form.paymentDescription} id=""></textarea>

        <button type="submit">{loading ? "Updating account..." : "Set Account Details"}</button>
      </form>

      <p style={{textAlign: "center"}}>
        <Link to={"/orders"}>&lt;&lt;Back to Orders</Link>
      </p>
    </div>
  );
};

export default BankAccountForm;
